import { Schema } from 'mongoose';
import localizedField, { ILocalizedText } from './localized-text';

export interface IInstruction {
  start?: ILocalizedText;
  end?: ILocalizedText;
}
const instructions = new Schema(
  {
    start: {
      type: localizedField,
    },
    end: {
      type: localizedField,
    },
  },
  { _id: false },
);

export default instructions;
